import { BRAND } from 'lib/data/video/types';
import { getSite } from './getSite';

const PLAYERS = [
  { id: 'th3qJyvz', title: 'Allas | Artikelspelare' },
  { id: '9FRIpC8Z', title: 'Aller | Autoplay' },
  { id: 'DC3x0LkZ', title: 'Aller | Click to play' },
  { id: 'G8hZwkSt', title: 'Aller | Muted Autoplay' },
  { id: 'Sd7gyNRp', title: 'BAAAM | Artikelspelare' },
  { id: 'R4fmTUE5', title: 'ELLE | Artikelspelare' },
  { id: '5PmgzQi5', title: 'Femina | Artikelspelare' },
  { id: 'oi4svUpH', title: 'Femina-ArticleBottom' },
  { id: '9TWH43LP', title: 'Femina-ArticleTop' },
  { id: 'BCsUScfV', title: 'Frida | Artikelspelare' },
  { id: 'YpqcJOqw', title: 'Hänt | Artikelspelare' },
  { id: '7mmYg1yZ', title: 'MåBra | Artikelspelare' },
  { id: '6UDw2kzG', title: 'Motherhood | Artikelspelare' },
  { id: 'BzIUeZ9c', title: 'Recept | Artikelspelare' },
  { id: 'nxnAskAP', title: 'Residence | Artikelspelare' },
  { id: 'iJmmtkAP', title: 'Svenskdam | Artikelspelare' },
];

const DEFAULT_PLAYER = { id: '9FRIpC8Z', title: 'Aller | Autoplay' };

const PROTECTED_DEFAULT_PLAYER = { id: 'lMp1VzN7', title: 'Default protected player' };

const normalizeTitle = (title: string) => title?.toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o');

const matchPlayer = (site: string) => (player: { id: string; title: string }) =>
  normalizeTitle(player.title).indexOf(site) >= 0;

export function getJwPLayer(site: string, protectedProperty: boolean = false) {
  if (protectedProperty) {
    return PROTECTED_DEFAULT_PLAYER;
  }

  return PLAYERS.find(matchPlayer(site)) || DEFAULT_PLAYER;
}

const VIDEO_PAGES_PLAYERS: { site: BRAND; id: string }[] = [
  { site: 'allas', id: 'fJNWZCLB' },
  { site: 'elle', id: 'ro8pElia' },
  { site: 'femina', id: 'I7TK0Fjs' },
  { site: 'hant', id: 'Gz20QY7I' },
  { site: 'mabra', id: 'x1yBo19c' },
  { site: 'residence', id: 'wlYrdqch' },
  { site: 'svenskdam', id: 'jHuknrFG' },
];

export function getVideoPagesJwPLayer() {
  return VIDEO_PAGES_PLAYERS.find((player) => player.site === getSite())?.id;
}
